import Methods from "../methods";
import {formatDate} from "../../util/date-util";

const orderGenList = (context, payload) => {
  const url = `api/orderGeneral`;
  return Methods.doGet(context, url, null);
}

const orderGenListWithFilter = (context, payload) => {
  const url = `api/orderGeneral-filters?${payload.params}`;
  return Methods.doGet(context, url, null);
}

const uptOrdGen = ({commit}, payload) => {
  const url = `api/orderGeneral`;
  return Methods.doPut(payload.context, url, payload.order, null);
}

const loadTracking = (context, payload) => {
  const url = `api/tracking/orderGeneral/${payload.idOrder}`;
  return Methods.doGet(context, url, null);
}

const downloadImportFile = (context, orderGeneralId) => {
  const url = `api/orderGeneral/${orderGeneralId}/download-import-file`;
  const fileName = `Carga_data_pedido_${orderGeneralId}.xlsx`;

  return Methods.doPostDonwload(context, url, {}, fileName, null);
};

export default {
  orderGenList,
  orderGenListWithFilter,
  uptOrdGen,
  loadTracking,
  downloadImportFile
}



// WEBPACK FOOTER //
// ./src/api/modules/OrderGeneralApi.js